// extracted by mini-css-extract-plugin
export default {"cut-card":"FeedCardCut_cut-card__Fo+E4","cut-card--horizontal":"FeedCardCut_cut-card--horizontal__2x51M","cut-card--collapsed":"FeedCardCut_cut-card--collapsed__wlqFo"};